var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"trigger d-flex align-items-center justify-content-center h-100",on:{"click":_vm.toggle}},[_c('a-tooltip',{attrs:{"title":"CloudShell","placement":"right"}},[_c('icon',{staticClass:"cloudsheel-icon",attrs:{"type":"cloudshell"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }